module.exports = __webpack_public_path__ + "static/img/党建展厅.6d40188f.png";